import { DashboardWorkflowStepState } from './enums/dashboard-workflow-step-state';

export class DashboardWorkflowDelayOptions {
    workflowStepState: DashboardWorkflowStepState;
}
